import React from 'react';

import { Icon } from '@rbilabs/universal-components';
import { Typography } from 'ucl/components/text';

import { ServiceMode } from 'generated/graphql-gateway';
import { SubHeading } from 'pages/order-confirmation/styled';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';
import { getHeadingForServiceMode } from 'utils/service-mode';

const ServiceModeHeading = ({ serviceMode }: { serviceMode: ServiceMode }) => {
  const isFastLaneEnabled = useFlag(LaunchDarklyFlag.ENABLE_FAST_LANE_DRIVE_THRU);
  const isMobileOrderForDriveThruLaneEnabled = useFlag(
    LaunchDarklyFlag.ENABLE_MOBILE_ORDER_DRIVE_THRU_LANE
  );

  const serviceModeHeadingConfig = getHeadingForServiceMode(
    isFastLaneEnabled,
    isMobileOrderForDriveThruLaneEnabled,
    serviceMode
  );

  return (
    serviceModeHeadingConfig && (
      <SubHeading>
        <Icon variant={serviceModeHeadingConfig.icon} />
        <Typography variant="headerTwo" mb="$0" ml="$2">
          {serviceModeHeadingConfig.heading}
        </Typography>
      </SubHeading>
    )
  );
};
export default ServiceModeHeading;
